import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { PageableResponse } from "../PageableResponse";

export type B000223FindRequest = Partial<{
  batchNoFrom: string;
  batchNoTo: string;
  name: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000223FindResponse = {
  batchNo: string;
  batchNm: string;
  pickingMethod: string;
};

export const B000223Find = (props: B000223FindRequest) => {
  return RestClient.get<PageableResponse<B000223FindResponse[]>>(
    "b000223/find",
    {
      params: props,
    }
  );
};

export type B000223GetRequest = {
  batchNo: string;
};

export const B000223Get = (props: B000223GetRequest) => {
  return RestClient.get("b000223/get", {
    params: props,
  });
};

//バッチ名表示
export const B000223BatchNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.batchNo === "") {
    methods.setValue("batchNm", data.batchNo);
    return;
  }
  await B000223Get({ batchNo: data.batchNo })
    .then((response) => {
      methods.setValue("batchNm", response.data.batchNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("batchNm", "");
    });
};
